import { createSlice } from "@reduxjs/toolkit";
import { openLink } from "api/api";

const initialState = {
  link: "",
  response: [],
  fullLink: "",
  responseOpenDoor: [],
  isLoading: false,
  flag: false,
  loadingPage: false,
};

const openLinkSlice = createSlice({
  name: "openLink",
  initialState,
  reducers: {
    setLink: (state, action) => {
      state.link = action.payload;
    },
    openLink: (state, action) => {
      state.response = action.payload;
      state.loadingPage = false;
    },
    setFullLink: (state, action) => {
      state.fullLink = action.payload;
    },
    openDoor: (state, action) => {
      state.fullLink = "";
      state.responseOpenDoor = action.payload;
      state.isLoading = false;
      state.flag = true;
    },
    updateIsLoading: (state) => {
      state.isLoading = true;
    },
    setFlagOpen: (state) => {
      state.flag = false;
    },
    setLoadingPage: (state) => {
      state.loadingPage = true;
    },
  },
});

export const {
  setLink,
  openLink: openLinkAction,
  setFullLink,
  openDoor,
  updateIsLoading,
  setFlagOpen,
  setLoadingPage,
} = openLinkSlice.actions;

// Асинхронные actions
export const fetchOpenLinkData = (link) => async (dispatch) => {
  try {
    const data = await openLink.getOpenLinkData(link);
    dispatch(openLinkAction(data));
  } catch (err) {
    console.log(err);
  }
};

export const fetchOpenDoor = (fullLink) => async (dispatch) => {
  try {
    dispatch(updateIsLoading());
    const data = await openLink.openDoor(fullLink);
    dispatch(openDoor(data));
  } catch (err) {
    console.log(err);
  }
};

export default openLinkSlice.reducer;
